<template>
  <ankh-list :showSearchForm="false">
    <template #btn-group>
      <el-button @click.native="$router.push('add')">{{$t('新增')}}</el-button>
      <!--  todo 导出   -->
<!--      <el-button>{{$t('导出')}}</el-button>-->
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #table="{height}">

      <table-list
          ref="list"
          :stripe="false"
          :height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          :span-method="handleSpanMethod"
          @selection-change="selection = $event">

        <el-table-column align="center" type="selection" width="50"/>
        <el-table-column align="center" prop="index" :label="$t('序号')" width="50" fixed />
        <el-table-column align="center" prop="langName" :label="$t('版本')" fixed />
        <el-table-column align="center" prop="unitName" :label="$t('单位名称')"/>
        <el-table-column align="center" prop="rate" :label="$t('换算率（1克=？）')"/>
        <el-table-column align="center" prop="unitRate" :label="$t('换算率（1单位=？克）')"/>
        <el-table-column align="center" prop="priority" :label="$t('展示优先级')"/>
        <el-table-column align="center" prop="showProtocolCode" :label="$t('展示优先级协议代码')"/>
        <el-table-column align="center" prop="unitProtocolCode" :label="$t('单位协议代码')"/>
        <el-table-column align="center" prop="remark" :label="$t('备注')"/>
        <el-table-column align="center" :label="$t('操作')" width="100">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="$router.push('edit?code=' + row.code)">{{$t('编辑')}}</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "UnitList",
  components: {AnkhList, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      addDialog: false,
    }
  },
  methods: {
    // 合并列
    handleSpanMethod({rowIndex, columnIndex}) {
      if ([0, 1, 6, 7, 8, 9, 10].includes(columnIndex)) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },


    async handleDelete(row) {
      try {
        await requestByTip(this.$api.intellectUnit.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.intellectUnit.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.intellectUnit.list, params);
        const list = res.intellectUnits;
        let data = this.formatData(list);
        this.tableData = data;
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    },

    formatData(list) {
      /**
       * 中文 cnName cnRate cnRateUnit
       * 英文 enName enRate enRateUnit
       */
      const target = [];

      list.forEach((item, index) => {
        const enItem = {
          index: index + 1,
          langName: this.$t('英文'),
          unitName: item.enName,
          rate: item.enRate,
          unitRate: item.enRateUnit,
          ...item,
        };

        const zhItem = {
          index: index + 1,
          langName: this.$t('中文'),
          unitName: item.cnName,
          rate: item.cnRate,
          unitRate: item.cnRateUnit,
          ...item
        };
        target.push(zhItem, enItem);
      })
      return target;
    },
  },

}
</script>

<style scoped>

</style>
